export const LectureTableConfig = [
  {
    title: "렉처 ID",
    dataIndex: "lecture.id",
    width: "5%"
  },
  {
    title: "렉처명",
    dataIndex: "lecture.title",
    width: "20%"
  },
  {
    title: "카테고리",
    dataIndex: "lecture.type",
    width: "10%"
  },
  {
    title: "수강인원",
    dataIndex: "lecture.lectureUserCount",
    width: "5%"
  },
  {
    title: "평균이수율",
    dataIndex: "lecture.lectureAverageProgressRate",
    width: "5%"
  },
  {
    title: "구독종류",
    dataIndex: "lecture.subscribeType",
    width: "10%"
  },
  {
    title: "강사명",
    dataIndex: "lecturer.name",
    width: "5%"
  },
  {
    title: "코스 ID",
    dataIndex: "course.id",
    width: "5%"
  },
  {
    title: "코스명",
    dataIndex: "course.title",
    width: "20%"
  },
  {
    title: "조직(회사)명[한글]",
    dataIndex: "organization.name",
    width: "5%"
  },
  // {
  //   title: "조직(회사)명[영어]",
  //   dataIndex: "organization.companyName",
  //   width: "5%"
  // },
  {
    title: "시작일",
    dataIndex: "lecture.startedAt",
    width: "10%",
    slots: { title: "startedAt" },
    scopedSlots: { customRender: "startedAt" }
  },
  {
    title: "종료일",
    dataIndex: "lecture.endedAt",
    width: "10%",
    slots: { title: "endedAt" },
    scopedSlots: { customRender: "endedAt" }
  }
  // {
  //   title: "생성일시",
  //   dataIndex: "chapter.createdAt",
  //   width: "10%",
  //   slots: { title: "createdAt" },
  //   scopedSlots: { customRender: "createdAt" }
  // },
  // {
  //   title: "수정일시",
  //   dataIndex: "chapter.updatedAt",
  //   width: "10%",
  //   slots: { title: "updatedAt" },
  //   scopedSlots: { customRender: "updatedAt" }
  // }
];
